import React from 'react';
import { SITE_TITLE, SITE_DESCRIPTION } from '../../../config/seo.constants';

interface SEOProps {
    title: string;
    description?: string;
}
const SEO: React.FunctionComponent<SEOProps> = ({ title, description }) => {
    return (
        <>
            <title>{`${SITE_TITLE} | ${title}`}</title>
            <meta name="description" content={description ?? SITE_DESCRIPTION} />
        </>
    );
};

export default SEO;
